import { useReducer } from "react";

// An interface for reducer state
interface ModalReducerState {
  isOpen: boolean;
  payload?: any;
}

const initial = (isOpen: boolean = false): ModalReducerState => ({
  isOpen,
});
const initialState: ModalReducerState = initial();

enum SHOW_ENUM {
  HIDE,
  SHOW,
  TOGGLE,
}

// An interface for reducer action
interface ModalReducerAction {
  type: SHOW_ENUM;
  payload?: any;
}

const hideAction = () => ({
  type: SHOW_ENUM.HIDE,
});
const showAction = (payload: any) => ({
  type: SHOW_ENUM.SHOW,
  payload,
});
const toggleAction = () => ({
  type: SHOW_ENUM.TOGGLE,
});

const reducer = (
  state: ModalReducerState = initialState,
  action: ModalReducerAction
) => {
  const { type, payload } = action;
  const { isOpen } = state;
  switch (type) {
    case SHOW_ENUM.HIDE:
      return { ...state, isOpen: false, payload: undefined };
    case SHOW_ENUM.SHOW:
      return { ...state, isOpen: true, payload };
    case SHOW_ENUM.TOGGLE:
      return { ...state, isOpen: !isOpen };
    default:
      return state;
  }
};

export interface UseModalPayload {
  status?: "success" | "error";
  message?: string;
}

interface IUseModal {
  isOpen: boolean;
  payload?: UseModalPayload;
  close: () => void;
  open: (payload?: any) => void;
  toggle: () => void;
}

const useModal = (initialShowing: boolean = false): IUseModal => {
  const [{ isOpen, payload }, dispatch] = useReducer(
    reducer,
    initial(initialShowing)
  );

  const close = () => dispatch(hideAction());
  const open = (payload?: any) => dispatch(showAction(payload));
  const toggle = () => dispatch(toggleAction());

  return {
    isOpen,
    payload,
    close,
    open,
    toggle,
  };
};

export default useModal;
